import { render, staticRenderFns } from "./building_table.vue?vue&type=template&id=8a7f0efc&"
import script from "./building_table.vue?vue&type=script&lang=js&"
export * from "./building_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports